module.exports = __webpack_public_path__ + "img/desktop_inactive.88a06bfc.svg";